module.exports = __webpack_public_path__ + "static/img/top-bg.4640c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-bg.png
// module id = ltfh
// module chunks = 1